import { useMemo } from 'react';
import classes from '../ReportResult/ReportResult.module.css';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import ScenarioContext from '../ReportResult/ScenarioContext';
import RoleplayRecording from '../ReportResult/RoleplayRecording';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import SkillRatings from '../ReportResult/SkillRatings';

const NewRealPlayLeftSection = ({ isLoadingResponse, playerRef }) => {
  const {
    scenarios,
    customer_context,
    selectedScenario,
    title,
    videoURL,
    endDate,
    persona_name: prospectName,
    formattedDate,
  } = RealPlayRecordDataHelper();

  const { rating_criteria, status_ai } = RealPlayQualifiedDataHelper();
  const customer_role = useMemo(() => customer_context?.role, [customer_context?.role]);
  const customer_industry = useMemo(() => customer_context?.industry, [customer_context?.industry]);
  const customer_situation = useMemo(
    () => customer_context?.situation,
    [customer_context?.situation]
  );

  return (
    <div className={classes.left}>
      {/* Scenario Context */}
      <ScenarioContext
        className={classes.scenarioContainer}
        date={endDate ? formattedDate(endDate) : ''}
        prospectName={prospectName}
        customer_role={customer_role}
        customer_industry={customer_industry}
        customer_situation={customer_situation}
        selectedScenario={selectedScenario}
        scenarios={scenarios}
        title={title}
      />
      {/* Roleplay Recording */}
      <RoleplayRecording
        className={classes.recordingContainer}
        videoURL={videoURL}
        playerRef={playerRef}
      />
      <SkillRatings
        rating_criteria={rating_criteria}
        status_ai={status_ai}
        isLoadingResponse={isLoadingResponse}
      />
    </div>
  );
};

export default NewRealPlayLeftSection;
